<div class="page-container kb-changes-container container">
  <div class="kb-changes-title-section">
    <div class="breadcrumb">
      <button mat-button (click)="nav('unified')">
        <mat-icon>home</mat-icon>
        <span class="text-container">Home</span>
      </button>
      /
      <button mat-button (click)="back('KB')" [disabled]="currentStep === 1">
        <span class="text-container">KB Changes</span>
      </button>
      @if (currentStep > 1) {
        /
        <button mat-button (click)="back()" [disabled]="currentStep === 2">
          <span class="text-container">{{ selectedKBTitle }}</span>
        </button>
        @if (currentStep > 2) {
          /
          <button mat-button [disabled]="currentStep === 3">
            <span class="text-container">{{ sectionChangeDataTitle }}</span>
          </button>
        }
      }
    </div>
    @if (currentStep === 1) {
      <div class="header">
        <h1>KB Changes</h1>
      </div>
    }
    @if (currentStep === 2) {
      <div class="header">
        @if (selectedKBTitle) {
          <h1>{{ selectedKBTitle }}</h1>
          <div class="change-date-container"
            ><p> Changes made on {{ selectedKBDate }} </p></div
          >
        }
      </div>
    }
    @if (currentStep === 3) {
      <div class="header">
        @if (sectionChangeDataTitle) {
          <h1>{{ sectionChangeDataTitle }}</h1>
          <div class="change-date-container"
            ><p> Changes made on {{ selectedKBDate }} </p></div
          >
        }
      </div>
    }
    @if (currentStep > 1 && !loading) {
      <button color="primary" mat-button (click)="back()"
        ><mat-icon>arrow_back</mat-icon>Back to {{ previousPageTitle }}</button
      >
    }
  </div>
  @if (sectionChangeDataAction && sectionChangeDataContent) {
    <div class="change-detail-container">
      <h3 class="{{ changeDataActionStyle }}">{{ sectionChangeDataAction }}</h3>
      <div class="change-detail-content">
        @for (line of sectionChangeDataContent; track $index) {
          <p>{{ line }}</p>
        }
      </div>
    </div>
  }
  @if (tableDisplayData && tableDisplayData.length > 0 && !loading) {
    <kendo-grid
      class="col-12 mt-3 usage-grid"
      [kendoGridBinding]="tableDisplayData"
      [height]="700"
      [pageSize]="pageSize"
      [pageable]="pageableData"
      [sortable]="true"
      [filterable]="'menu'"
      [filter]="state.filter"
      (filterChange)="updateFilters($event)"
      [navigable]="true"
    >
      <kendo-grid-column [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button
            mat-icon-button
            class="fs-button"
            (click)="getDetailBtnFunction(dataItem)"
            color="primary"
            matTooltip="See KB Details"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </ng-template>
      </kendo-grid-column>
      @for (col of tableDisplayHeaders; track $index) {
        <kendo-grid-column
          [field]="col.DataField"
          [title]="col.Label"
          [hidden]="col.Hidden"
        ></kendo-grid-column>
      }
    </kendo-grid>
  }
  @if (loading) {
    <app-simple-loading
      class="pt-3"
      [message]="'Loading KB Change History...'"
    ></app-simple-loading>
  }
</div>
